import { t } from "i18next";
import type { JSX } from "react";
import MicrophoneIcon from "@/assets/icons/mic.svg?react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface Props {
  onClick: () => void;
  disabled?: boolean;
}

export const MicrophoneButton = (props: Props): JSX.Element => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            className="inline-flex cursor-pointer disabled:cursor-not-allowed disabled:opacity-50"
            disabled={props.disabled}
            onClick={props.onClick}
          >
            <MicrophoneIcon
              aria-label={t("components.microphoneButton.label")}
              height={100}
              strokeWidth={0.5}
              width={100}
            />
          </button>
        </TooltipTrigger>
        <TooltipContent>
          <p>{t("components.microphoneButton.tooltip")}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
